import { render, staticRenderFns } from "./SalesTaxWorkflowList.vue?vue&type=template&id=c356f9ac&scoped=true&"
import script from "./SalesTaxWorkflowList.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxWorkflowList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c356f9ac",
  null
  
)

export default component.exports